/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Section_2_EInputs */



/**
* | output |
* | --- |
* | "This feature does not guarantee complete content filtering and is not a substitute for organizational compliance measures" |
*
* @param {Guardrails_Section_2_EInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_section_2_e = /** @type {((inputs?: Guardrails_Section_2_EInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Section_2_EInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("die Funktion keine Garantie für vollständige Content-Filterung bietet und keinen Ersatz für organisatorische Compliance-Maßnahmen darstellt")
	return /** @type {LocalizedString} */ ("This feature does not guarantee complete content filtering and is not a substitute for organizational compliance measures")
});